import React, { PropTypes } from 'react';
import { FlatButton, IconButton, TextField } from 'material-ui';
import TwoColumnRow from '../../tc-ui/two-column-row';
import GenericRightSideLayout from './right-side-layout';
import AddOrg from './addOrg';
import { call, cond, propEq, always, T } from 'ramda';

const EditMemberships = props => {
  const {
    updateProps,
    membershipsReducer,
    deleteOneOrganization,
    updateProfileBadge,
    isSupplier,
    sortedMemberships,
  } = props;

  const updateMembershipsEditState = (membershipsEditState) => {
    updateProps({
      membershipsEditState,
      cancelClicked: false,
    });
  };

  return (
    <GenericRightSideLayout
      isSupplier={isSupplier}
      leftColumnContentText="Industry Memberships / Organizations"
      rightColumnContentText={membershipsReducer.membershipsEditState ? <span/> :
        <div>
          <FlatButton
            label="Edit"
            labelStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontWeight: '600' }}
            style={{ backgroundColor: '#d8d8d8', width: '8vw', height: '28px', lineHeight: '1.5' }}
            onTouchTap={() => updateMembershipsEditState(true)}
          />
        </div>
      }
      mainContent={
        <div style={isSupplier ? { padding: '1% 2.2%' } : { marginBottom: '20px' }}>
          {
            sortedMemberships.length ?
              <div>
                {
                  sortedMemberships.filter(org => !org.delete && org.badgeId !== '5ec074e495512b0156baf64f').map((membership, index) => {
                    return (
                      <div key={index}>
                        <TwoColumnRow
                          leftColumnContent={
                            <span style={{ display: 'inline-block' }}>
                              {membership.name}
                              {
                                membershipsReducer.membershipsEditState ?
                                  <IconButton
                                    iconClassName="tc-icon-delete2"
                                    iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', margin: '-10px 0 0 -20px', verticalAlign: 'middle' }}
                                    onTouchTap={() => {
                                      deleteOneOrganization(membership.name);
                                      updateProps({ disableMembershipsSaveButton: false });
                                    }}
                                  /> : <span/>
                              }
                            </span>
                          }
                          leftColumnStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', textAlign: 'left', width: '45%' }}
                          rightColumnStyle={{ width: '50%', marginRight: '10px' }}
                          rightColumnContent={<TextField
                            name="membershipId"
                            key={`membershipTF${membership.name}`}
                            id={`membershipTF${membership.name}`}
                            value={membership.membershipId || ''}
                            onChange={({ target: { value } }) => {
                              const newObj = {
                                name: membership.name,
                                membershipId: value,
                                type: 'organization',
                                verifiedStatus: 'pending',
                                badgeId: membership.badgeId,
                                companyBadgeId: membership.companyBadgeId,
                              };
                              const omitOldObj = membershipsReducer.memberships.filter(org => org.name !== membership.name);
                              updateProps({ memberships: omitOldObj.concat([newObj]) });
                            }}
                            style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px', margin: '5px 0 15px 0' }}
                            inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' }}
                            underlineShow={false}
                            hintText="Membership ID"
                            hintStyle={{ marginLeft: '5px', fontSize: '12px', marginBottom: '-5px', maxHeight: '20px' }}
                          />}
                        />
                      </div>
                    );
                  })
                }
              </div> : <span/>
          }
          <AddOrg />
          {
            membershipsReducer.showAddAnotherOrganizationButton ?
              <div
                className="div-link"
                style={{ fontSize: '14px', textAlign: 'left', marginLeft: '30.5%', marginTop: '-5px', display: 'inline-block', fontWeight: '600' }}
                onClick={() => updateProps({
                  resetOtherMembershipObj: membershipsReducer.otherMembershipValidated || membershipsReducer.membershipValidated,
                  showAddAnotherOrganizationButton: false,
                })}
              >
                ADD ANOTHER ORGANIZATION
              </div> : <span/>
          }
        </div>
      }
      shouldSaveCancelButtonsShow={membershipsReducer.membershipsEditState}
      saveCancelOuterDivStyle={isSupplier ? { paddingBottom: '3%', textAlign: 'right', marginRight: '27px', clear: 'both', paddingTop: membershipsReducer.showAddAnotherOrganizationButton ? '10px' : '20px' }
        : { textAlign: 'right', marginRight: '10px', clear: 'both', paddingTop: membershipsReducer.showAddAnotherOrganizationButton ? '10px' : '20px' }}
      cancelOnTouchTapFunc={() => {
        updateMembershipsEditState(false);
        updateProps({ cancelMembershipsClicked: true });
      }}
      saveOnTouchTapFunc={() => {
        updateMembershipsEditState(false);
        updateProps({
          originalMemberships: membershipsReducer.memberships,
          resetOtherMembershipObj: true,
          membershipsCompleted: true,
          showAddAnotherOrganizationButton: false,
        });
        updateProfileBadge({ memberships: call(cond([
          [propEq('otherMembershipValidated', true), always(membershipsReducer.memberships.concat([membershipsReducer.otherMembership]))],
          [propEq('membershipValidated', true), always(membershipsReducer.memberships.concat([membershipsReducer.membership]))],
          [T, always(membershipsReducer.memberships)],
        ]), membershipsReducer) });
      }}
      shouldSaveButtonBeDisabled={membershipsReducer.disableMembershipsSaveButton}
    />
  );
};

EditMemberships.propTypes = {
  membershipsReducer: PropTypes.object,
  updateProps: PropTypes.func,
  updateProfileBadge: PropTypes.func,
  deleteOneOrganization: PropTypes.func,
  isSupplier: PropTypes.bool,
  sortedMemberships: PropTypes.array,
};

export default EditMemberships;



// WEBPACK FOOTER //
// ./src/app/components/profile/memberships/edit-state.jsx